import { ReactNode } from "react";

export function ErrorMessage({ children }: { children: ReactNode }) {
	return <span className="text-danger">{children}</span>;
}
